import { tns } from "../../../node_modules/tiny-slider/src/tiny-slider"

if ($('.slider-model')) {
    var tnsCarousel = document.querySelectorAll('.slider-model');
    tnsCarousel.forEach(slider => {
        var tnsSlider = tns({
            container: slider,
            items: 1,
            slideBy: 1,
            autoplay: false,
            mouseDrag: false,
            arrowKeys: true,
            lazyload: true,
            loop: false,
            responsive: {
                520: {
                    items: 2
                },
                720: {
                    items: 2
                },
                960: {
                    items: 3
                },
                1140: {
                    items: 4
                }
            }
        });
    });
}
